/**
 * Welke gegevensbron niet geladen is, met zijn eigen naam in de melding.
 *
 * Een kaart als Maatschappelijke waarde telt drie stromen op die elk hun eigen
 * bron hebben, en die konden alledrie dezelfde melding geven: 'Rekenparameters
 * niet geladen'. Die tekst noemt precies één van de drie, dus bij de andere
 * twee staat er iets onwaars op het scherm en wijst de diagnose de verkeerde
 * kant op — gemeten: de effect-catalogus was geblokkeerd, de rekenparameters
 * waren binnen, en er is een uur gezocht in de verkeerde hoek.
 *
 * Alle mislukte bronnen worden genoemd, niet alleen de eerste: valt er meer dan
 * één weg, dan is juist dát het signaal (meestal dezelfde storing).
 *
 * AI-CONTEXT: See docs/pitfalls.md#dev-gate-counter-hides-its-own-policy
 *
 * @typedef {[string, (Error|null|undefined)]} BronMetFout Naam van de bron in
 *   kleine letters, en de fout van zijn hook (falsy = geladen)
 *
 * @param {Array<BronMetFout>} [sources] - De bronnen in de volgorde waarin ze genoemd horen te worden
 * @returns {string|null} De melding, of null zolang elke bron geladen is
 */
const dataSourceErrorMessage = (sources) => {
    const missing = (sources || [])
        .filter(([, error]) => Boolean(error))
        .map(([label]) => label)

    if (missing.length === 0) return null

    const last = missing[missing.length - 1]
    const rest = missing.slice(0, -1)
    const opsomming = rest.length === 0 ? last : `${rest.join(', ')} en ${last}`

    return `${opsomming.charAt(0).toUpperCase()}${opsomming.slice(1)} niet geladen`
}

export default dataSourceErrorMessage
